import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AppConfigService } from 'src/environments/app-config.service';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

@Component({
  standalone: false,
  selector: 'app-modal-retry-register',
  templateUrl: './modal-retry-register.component.html',
  styleUrls: ['./modal-retry-register.component.scss']
})
export class ModalRetryRegisterComponent implements OnInit, AfterViewInit {

  private environment: any

  title: string = '';
  closeButton: boolean = false;
  modalTitleType: 'error' | 'warning' | 'success' | 'pattern' = 'pattern';
  modalType: 'info'| 'confirmation' = 'info';
  content: string = '';
  confirmation: boolean = false; 

  constructor(
   public dialogRef: AppModalOverlayRef<ModalRetryRegisterComponent>,
   private appConfig: AppConfigService,
   private el: ElementRef,
   private renderer: Renderer2,
  ) {
    this.environment = this.appConfig.config;
  }

  ngOnInit(): void {
    this.setVariables();
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  get headerIcon(): string {
    switch (this.modalTitleType) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      default:
        return 'info';
    }
  }

  get headerIconTone(): string {
    switch (this.modalTitleType) {
      case 'error':
        return 'danger';
      case 'warning':
        return 'warning';
      case 'success':
        return 'success';
      default:
        return 'default';
    }
  }

  confirm(): void{
    this.dialogRef.data = {
      confirmation: true
    };
    this.dialogRef.close(this.dialogRef.data);
  }

  close(): void{
    this.dialogRef.close();
  }

  setVariables(): void{
    const data = this.dialogRef.data;
    if(data) {
      this.title = data.title ?? data.title;
      this.modalTitleType = data.modalTitleType ?? data.modalTitleType;
      this.modalType = data.modalType ?? data.modalType;
      this.content = data.content ?? data.content;
      this.confirmation = data.confirmation ?? data.confirmation;
      this.closeButton = data.closeButton ?? data.closeButton;
    }
  }

  openLinkSuporte(): void {
    window.open(this.environment.urlSuporteB3, '_blank');
  }
}
